/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';

export default function Icon({ title = null, color = null, id = null }) {
  return (
    <svg id={id} role="img" aria-labelledby="magnifyingGlassIcon" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title id="magnifyingGlassIcon">{title}</title>}
      <path d="M21.2857 21.2857L16.2857 16.2857" stroke={color || '#585F69'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5714 18.4286C14.9108 18.4286 18.4286 14.9108 18.4286 10.5714C18.4286 6.23206 14.9108 2.71429 10.5714 2.71429C6.23206 2.71429 2.71429 6.23206 2.71429 10.5714C2.71429 14.9108 6.23206 18.4286 10.5714 18.4286Z" stroke={color || '#585F69'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Icon.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  id: PropTypes.string,
};
